export const BLOG_PAGE_ID = 'blog';
export const FORUM_PAGE_ID = 'forum';
export const FORUM_WIDGET_ID = 'forum_header_widget';
export const MEMBERS_PAGE_ID = 'members';



// WEBPACK FOOTER //
// ./app/constants/component-ids.js